/*
 * @Description: 后端通用响应 / 分页类型
 * @Author: liushichuan
 */

/** 后端返回的业务码（只列出前端用到的） */
export enum ResponseCode {
  /** 登录已过期 */
  LOGIN_EXPIRED = 6069,
  /** token 为空 */
  TOKEN_IS_NULL = 6070,
  /** 非法登录 */
  ILLEGAL_LOGIN = 6071,
}

/** 后端统一响应体 */
export interface ResponseResult<T> {
  code: ResponseCode;
  data: T | null;
  msg?: string | null;
  expMsg?: string | null;
}

/** 请求失败时 reject 出来的响应体 */
export type ResponseError = ResponseResult<unknown>;

/** 分页请求参数 */
export interface PaginationParams {
  /** 当前页 */
  pageIndex?: number;
  /** 每页条数 */
  pageSize?: number;
}

/** 分页响应 */
export interface PaginationResult<T> {
  /** 总页数 */
  pageCount: number;
  /** 当前页 */
  pageIndex: number;
  /** 每页条数 */
  pageSize: number;
  /** 数据列表 */
  rows: T[];
  /** 总数 */
  total: number;
}
